import { showToast } from '@design-system';
import {
    HolidayToCreate,
    HolidayType,
    Operator,
    useCreateHolidayMutation,
    useGetHolidayTypesMutation,
    useGetUsersMutation
} from '@services';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useNewCongePageVM = () => {
    const [holidayToCreate, setHolidayToCreate] = useState<HolidayToCreate>({
        type_id: '',
        date_start: '',
        date_end: '',
        operator_id: ''
    });
    const [operators, setOperators] = useState<Operator[]>([]);
    const [holidayTypes, setHolidayTypes] = useState<HolidayType[]>([]);

    const [createHoliday, { isLoading, data: dataCreateHoliday, error: errorCreateHoliday }] = useCreateHolidayMutation();
    const [getHolidayTypes, { isLoading: isLoadingHolidayTypes, error: errorHolidayTypes, data: dataHolidayTypes }] =
        useGetHolidayTypesMutation();
    const [getUsers, { isLoading: isLoadingUsers, error: errorUsers, data: users }] = useGetUsersMutation();
    const navigate = useNavigate();

    const handleCreateHoliday = (holiday: HolidayToCreate) => {
        createHoliday(holiday);
    };

    const handleUpdateHolidayToCreate = (key: keyof HolidayToCreate, value: string) => {
        setHolidayToCreate({ ...holidayToCreate, [key]: value });
    };

    useEffect(() => {
        getHolidayTypes(undefined);
        getUsers(undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (users) {
            setOperators(users.operators);
        }
        if (errorUsers) {
            console.error(errorUsers);
        }
    }, [users, isLoadingUsers, errorUsers]);

    useEffect(() => {
        if (errorHolidayTypes) {
            console.error(errorHolidayTypes);
        }
        if (dataHolidayTypes) {
            setHolidayTypes(dataHolidayTypes);
        }
    }, [errorHolidayTypes, dataHolidayTypes, isLoadingHolidayTypes]);

    useEffect(() => {
        if (dataCreateHoliday) {
            showToast({
                message: "Demande d'absence créée avec succès",
                type: 'success'
            });
            navigate('/richesses-humaines/conges');
        }
        if (errorCreateHoliday) {
            console.error(errorCreateHoliday);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCreateHoliday, errorCreateHoliday]);

    return {
        handleCreateHoliday,
        handleUpdateHolidayToCreate,
        holidayTypes,
        holidayToCreate,
        isLoading: isLoading || isLoadingHolidayTypes || isLoadingUsers,
        error: errorCreateHoliday || errorHolidayTypes || errorUsers,
        operators,
        isHolidayFilled: Object.values(holidayToCreate).every((value) => value !== '')
    };
};
